import { setDefaultOptions } from 'date-fns'
import { de as de_date_fns } from 'date-fns/locale'
import { Outlet } from 'react-router-dom'

import CustomSidebar from '../sidebar/Sidebar'

import Header from './header/Header'

import { Toaster } from '@/components/ui/sonner'

const Layout = () => {
  const initializeLocale = () => {
    // Set date-fns Date options
    setDefaultOptions({
      locale: de_date_fns,
      weekStartsOn: 1,
    })
  }
  initializeLocale()

  return (
    <div className="max-w-screen flex min-h-screen flex-col">
      <Toaster />
      <CustomSidebar />
      <Header />
      <div className="mx-auto w-full">
        <Outlet />
      </div>
    </div>
  )
}

export default Layout
